export default {
  path: "/",
  name: "Admin",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/bulk_uploads",
      name: "Bulk Uploads",
      component: () => import("@/views/admin/bulk-uploads/Index"),
    },
    {
      path: "/eventaction",
      name: "Hooks (Event Actions) ",
      component: () => import("@/views/admin/hooks_event_actions/Index.vue"),
    },

    {
      path: "/online_payments",
      name: "Payment Transactions",
      component: () => import("@/views/admin/online_payments/Index.vue"),
    },
    {
      path: "/message_log",
      name: "Message Log",
      component: () => import("@/views/admin/message_log/index.vue"),
    },
    {
      path: "/scheduler_jobs",
      name: "Scheduler Jobs",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/admin/jobs/Index.vue"),
        },
        {
          path: "/scheduler_history/:id",
          name: "Scheduler History",
          component: () => import("@/views/admin/jobs/SchedulerHistory.vue"),
        },
        {
          path: "/view_scheduler_job/:id",
          name: "View Scheduler Jobs",
          component: () => import("@/views/admin/jobs/view-jobs/Index.vue"),
        },
      ],
    },
    {
      path: "/maker-checker-action",
      name: "Maker Checker Action",
      component: () => import("@/views/admin/maker_checker_action/index.vue"),
    },
  ],
};
